import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

export interface VehicleAlert {
  type: 'itv';
  priority: 'overdue' | 'urgent' | 'upcoming';
  title: string;
  message: string;
  vehicle_id: number;
  vehicle_name: string;
  vehicle_plate: string;
  date: string;
}

@Injectable({
  providedIn: 'root'
})
export class VehicleAlertService {
  private API = environment.API_URL;
  private alertsSubject = new BehaviorSubject<VehicleAlert[]>([]);
  private alertCountSubject = new BehaviorSubject<number>(0);

  public alerts$ = this.alertsSubject.asObservable();
  public alertCount$ = this.alertCountSubject.asObservable();

  constructor(private http: HttpClient) {}

  loadAlerts(): void {
    this.http.get<any>(`${this.API}/config/vehicles/alerts`).subscribe({
      next: (response) => {
        if (response.success) {
          this.alertsSubject.next(response.data);
          this.alertCountSubject.next(response.data.length);
        }
      },
      error: (error) => console.error('Error loading vehicle alerts:', error)
    });
  }
}
